var map = {
	"./dashboard_emails.png": 55,
	"./dashboard_emails_2x.png": 99,
	"./dashboard_highlight.png": 82,
	"./dashboard_highlight_2x.png": 102,
	"./dashboard_tags.png": 61,
	"./dashboard_tags_2x.png": 101,
	"./dashboard_unhighlight.png": 81,
	"./dashboard_unhighlight_2x.png": 103,
	"./email_attachement.png": 1,
	"./email_attachement_2x.png": 14,
	"./email_delete.png": 80,
	"./email_delete_2x.png": 104,
	"./email_download.png": 30,
	"./email_download_2x.png": 33,
	"./email_folder.png": 79,
	"./email_folder_2x.png": 105,
	"./email_header_hide.png": 78,
	"./email_header_hide_2x.png": 107,
	"./email_header_show.png": 77,
	"./email_header_show_2x.png": 106,
	"./email_you.png": 24,
	"./email_you_2x.png": 108,
	"./filter_clear.png": 73,
	"./filter_clear_2x.png": 109,
	"./filter_clear_gray.png": 13,
	"./filter_clear_gray_2x.png": 15,
	"./filter_date.png": 75,
	"./filter_date_2x.png": 110,
	"./filter_folder.png": 7,
	"./filter_folder_2x.png": 16,
	"./filter_person.png": 6,
	"./filter_person_2x.png": 34,
	"./filter_sample.png": 2,
	"./filter_sample_2x.png": 111,
	"./filter_star.png": 74,
	"./filter_star_2x.png": 112,
	"./filter_tag.png": 21,
	"./filter_tag_2x.png": 35,
	"./filterbutton.png": 31,
	"./filterbutton_2x.png": 36,
	"./folder_add.png": 26,
	"./folder_add_2x.png": 113,
	"./folder_alpha.png": 60,
	"./folder_alpha_2x.png": 115,
	"./folder_alpha_gray.png": 59,
	"./folder_alpha_gray_2x.png": 114,
	"./folder_arrow_down.png": 69,
	"./folder_arrow_down_2x.png": 116,
	"./folder_arrow_up.png": 70,
	"./folder_arrow_up_2x.png": 117,
	"./folder_delete.png": 4,
	"./folder_delete_2x.png": 17,
	"./folder_descriptions_hide.png": 64,
	"./folder_descriptions_hide_2x.png": 118,
	"./folder_descriptions_show.png": 63,
	"./folder_descriptions_show_2x.png": 119,
	"./folder_edit_icon.png": 89,
	"./folder_edit_icon_2x.png": 120,
	"./folder_icon.png": 27,
	"./folder_icon_2x.png": 124,
	"./folder_icon_another_team.png": 10,
	"./folder_icon_another_team_2x.png": 121,
	"./folder_icon_green.png": 72,
	"./folder_icon_green_2x.png": 122,
	"./folder_icon_specific.png": 9,
	"./folder_icon_specific_2x.png": 123,
	"./folder_lock_icon.png": 88,
	"./folder_lock_icon_2x.png": 125,
	"./folder_recency.png": 58,
	"./folder_recency_2x.png": 127,
	"./folder_recency_gray.png": 57,
	"./folder_recency_gray_2x.png": 126,
	"./folder_star.png": 8,
	"./folder_star_2x.png": 37,
	"./folder_star_gray.png": 3,
	"./folder_star_gray_2x.png": 18,
	"./folder_star_order.png": 56,
	"./folder_star_order_2x.png": 128,
	"./folder_star_white.png": 65,
	"./folder_star_white_2x.png": 129,
	"./folder_star_white_active.png": 68,
	"./folder_star_white_active_2x.png": 130,
	"./foldermanager_header_asc.png": 66,
	"./foldermanager_header_asc_2x.png": 131,
	"./foldermanager_header_desc.png": 67,
	"./foldermanager_header_desc_2x.png": 132,
	"./folders_icon.png": 25,
	"./folders_icon_2x.png": 100,
	"./folders_person.png": 11,
	"./folders_person_2x.png": 20,
	"./folders_person_different_team.png": 29,
	"./folders_person_different_team_2x.png": 38,
	"./folders_person_unactivated.png": 12,
	"./folders_person_unactivated_2x.png": 19,
	"./footer-bg.png": 50,
	"./header_dashboard.png": 44,
	"./header_dashboard_2x.png": 91,
	"./header_folders.png": 46,
	"./header_folders_2x.png": 93,
	"./header_help.png": 48,
	"./header_help_2x.png": 95,
	"./header_logo.png": 160,
	"./header_logo_2x.png": 90,
	"./header_logout.png": 49,
	"./header_logout_2x.png": 96,
	"./header_mail.png": 45,
	"./header_mail_2x.png": 92,
	"./header_settings.png": 47,
	"./header_settings_2x.png": 94,
	"./help_tick.png": 28,
	"./help_tick_2x.png": 98,
	"./help_tick_grey.png": 62,
	"./help_tick_grey_2x.png": 97,
	"./icon_arrow_grey.png": 83,
	"./icon_arrow_grey_2x.png": 133,
	"./mailbox-exchange.png": 161,
	"./mailbox-gmail.png": 162,
	"./mailbox-imap.png": 163,
	"./mailbox-office365.png": 164,
	"./mailbox_connected_large.png": 22,
	"./mailbox_connected_large_2x.png": 39,
	"./mailbox_failed.png": 23,
	"./mailbox_failed_2x.png": 40,
	"./message_saved.png": 42,
	"./message_saved_2x.png": 134,
	"./modal-pane-white.png": 71,
	"./raise_confirm.png": 51,
	"./raise_confirm_2x.png": 135,
	"./raise_error.png": 53,
	"./raise_error_2x.png": 136,
	"./raise_message.png": 52,
	"./raise_message_2x.png": 137,
	"./raise_warning.png": 54,
	"./raise_warning_2x.png": 138,
	"./save-emails-help-step-1.png": 165,
	"./save-emails-help-step-2.png": 166,
	"./save-emails-help-step-3.png": 167,
	"./settings_folder.png": 85,
	"./settings_folder_2x.png": 140,
	"./settings_mailbox.png": 87,
	"./settings_mailbox_2x.png": 142,
	"./settings_profile.png": 86,
	"./settings_profile_2x.png": 141,
	"./settings_team.png": 84,
	"./settings_team_2x.png": 139,
	"./step-1.png": 168,
	"./step-1_ff.png": 169,
	"./step-1_ie.png": 170,
	"./step-2.png": 171,
	"./step-3.png": 172,
	"./stripe_gradient.png": 76,
	"./stripe_gradient_2x.png": 143,
	"./tag.png": 5,
	"./tag_2x.png": 32
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 159;


//////////////////
// WEBPACK FOOTER
// ./src/images nonrecursive \.(png|jpe?g|svg)$
// module id = 159
// module chunks = 0 1